import { useSuspenseQuery } from '@apollo/client';
import { FETCH_ADMIN_PAGE, FetchAdminPageQuery, FetchAdminPageQueryVariables } from '@edwin-group/cj-graphql';

export const useAdmin = () => {
  const { data, error } = useSuspenseQuery<FetchAdminPageQuery, FetchAdminPageQueryVariables>(FETCH_ADMIN_PAGE, {
    fetchPolicy: 'cache-and-network',
  });

  return { page: data?.adminPage ?? null, error };
};
